/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/PerformanceIndicatorDataBase'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./PerformanceIndicatorDataBase'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorDataReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.PerformanceIndicatorDataBase);
  }
}(this, function(ApiClient, CorporateStructureLink, PerformanceIndicatorDataBase) {
  'use strict';




  /**
   * The PerformanceIndicatorDataReport model module.
   * @module model/PerformanceIndicatorDataReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorDataReport</code>.
   * @alias module:model/PerformanceIndicatorDataReport
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>PerformanceIndicatorDataReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorDataReport} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorDataReport} The populated <code>PerformanceIndicatorDataReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'String');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('DataSourceID')) {
        obj['DataSourceID'] = ApiClient.convertToType(data['DataSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('HasActual')) {
        obj['HasActual'] = ApiClient.convertToType(data['HasActual'], 'Boolean');
      }
      if (data.hasOwnProperty('HasBudget')) {
        obj['HasBudget'] = ApiClient.convertToType(data['HasBudget'], 'Boolean');
      }
      if (data.hasOwnProperty('HasForecast')) {
        obj['HasForecast'] = ApiClient.convertToType(data['HasForecast'], 'Boolean');
      }
      if (data.hasOwnProperty('HasGoal')) {
        obj['HasGoal'] = ApiClient.convertToType(data['HasGoal'], 'Boolean');
      }
      if (data.hasOwnProperty('ValueDependencyRuleID')) {
        obj['ValueDependencyRuleID'] = ApiClient.convertToType(data['ValueDependencyRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('NegateFinancialValue')) {
        obj['NegateFinancialValue'] = ApiClient.convertToType(data['NegateFinancialValue'], 'Boolean');
      }
      if (data.hasOwnProperty('ValueSuffix')) {
        obj['ValueSuffix'] = ApiClient.convertToType(data['ValueSuffix'], 'String');
      }
      if (data.hasOwnProperty('LastActualUpdate')) {
        obj['LastActualUpdate'] = ApiClient.convertToType(data['LastActualUpdate'], 'Date');
      }
      if (data.hasOwnProperty('Data')) {
        obj['Data'] = ApiClient.convertToType(data['Data'], [PerformanceIndicatorDataBase]);
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
    }
    return obj;
  }

  /**
   * @member {String} ID
   * @default ''
   */
  exports.prototype['ID'] = '';
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} PeriodTypeID
   * @default 0
   */
  exports.prototype['PeriodTypeID'] = 0;
  /**
   * @member {Integer} DimensionID
   */
  exports.prototype['DimensionID'] = undefined;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} DataSourceID
   * @default 0
   */
  exports.prototype['DataSourceID'] = 0;
  /**
   * @member {Boolean} HasActual
   * @default false
   */
  exports.prototype['HasActual'] = false;
  /**
   * @member {Boolean} HasBudget
   * @default false
   */
  exports.prototype['HasBudget'] = false;
  /**
   * @member {Boolean} HasForecast
   * @default false
   */
  exports.prototype['HasForecast'] = false;
  /**
   * @member {Boolean} HasGoal
   * @default false
   */
  exports.prototype['HasGoal'] = false;
  /**
   * @member {Integer} ValueDependencyRuleID
   * @default 0
   */
  exports.prototype['ValueDependencyRuleID'] = 0;
  /**
   * @member {Boolean} NegateFinancialValue
   * @default false
   */
  exports.prototype['NegateFinancialValue'] = false;
  /**
   * @member {String} ValueSuffix
   * @default ''
   */
  exports.prototype['ValueSuffix'] = '';
  /**
   * @member {Date} LastActualUpdate
   */
  exports.prototype['LastActualUpdate'] = undefined;
  /**
   * @member {Array.<module:model/PerformanceIndicatorDataBase>} Data
   */
  exports.prototype['Data'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;



  return exports;
}));


